import { zipCodeMapLayerSelector } from '@/redux/store/slices/map/mapSlice'
import { useAppSelector } from '@redux/hooks/useAppState'
import { Source } from 'react-map-gl/mapbox'

import { StyledMapLabelLayer } from './StyledMapLabelLayer'
import { StyledMapLineLayer } from './StyledMapLineLayer'

const useShowZipCodeMapLayer = () => {
	const zipCodeLayerVisible = useAppSelector(zipCodeMapLayerSelector)

	return zipCodeLayerVisible
}

export const ZipCodesMapLayer = ({ beforeId }: { beforeId: { beforeId?: string } }) => {
	const displayZipCodeLayer = useShowZipCodeMapLayer()

	if (!displayZipCodeLayer) {
		return null
	}

	return (
		<Source id="zip-code-boundaries" type="vector" url="mapbox://honeygrid.zipcodeswithres">
			<StyledMapLineLayer id="zip-code-boundaries-line-high-res" source-layer="zipCodesHighRes" />
			<StyledMapLineLayer id="zip-code-boundaries-line-low" source-layer="zipCodesLowRes" />
			<StyledMapLabelLayer {...beforeId} id="zip-code-labels" source-layer="zipCodesHighRes" />
		</Source>
	)
}
